module.exports = __webpack_public_path__ + "img/img (7).7788a0aa.jpg";